import { RouteEnum } from '@/constants/enums/RouteEnum';
import adMgmShareKey from '@/middleware/adMgmShareKey';
import auth from '@/middleware/auth';
import device from '@/middleware/device';
import webview from '@/middleware/webview';
import type { RouteRecordRaw } from 'vue-router';

/**
 * 行銷廣告用的活動單頁面 or 其他不需登入即可瀏覽的頁面
 */
export const landingPageRoutes: RouteRecordRaw[] = [
  {
    /**
     * 政策條款頁面
     */
    path: '/policy-and-terms',
    name: RouteEnum.PolicyTerms,
    component: () => import('@/views/policyTerms/index.vue'),
    meta: {
      layout: 'NoLayout',
      middleware: [auth]
    }
  },
  // 2026/07/20 移除金磚菁英領航計畫
  // {
  //   /**
  //    * 金磚菁英領航計畫
  //    */
  //   path: '/branding',
  //   name: RouteEnum.LandingBranding,
  //   component: () => import('@/views/newLanding/BrandingView.vue'),
  //   meta: {
  //     layout: 'NoLayout',
  //     middleware: [auth, adMgmShareKey, device]
  //   }
  // },
  // 2026/05/13 Francky 指示移除上市櫃人才專區按鈕，改由客服人員回應相關問題
  // {
  //   /**
  //    * 上市櫃專區 - 活動頁
  //    */
  //   path: '/MZlink',
  //   name: RouteEnum.LandingElite,
  //   component: () => import('@/views/newLanding/EliteView.vue'),
  //   meta: {
  //     layout: 'NoLayout',
  //     middleware: [auth, adMgmShareKey, device]
  //   }
  // },
  // {
  //   /**
  //    * 上市櫃專區 - 台灣上市上櫃公司清單
  //    */
  //   path: '/MZlink-list',
  //   name: RouteEnum.LandingEliteList,
  //   component: () => import('@/views/newLanding/EliteListView.vue'),
  //   meta: {
  //     layout: 'NoLayout',
  //     middleware: [auth, adMgmShareKey, device]
  //   }
  // },
  // {
  //   /**
  //    * 新版通用註冊 (暫時停用)
  //    */
  //   path: '/LPlink',
  //   name: RouteEnum.LandingRegisterSingle,
  //   component: () => import('@/views/newLanding/RegisterSingleView.vue'),
  //   meta: {
  //     layout: 'NoLayout',
  //     middleware: [auth, adMgmShareKey, device]
  //   }
  // },
  {
    /**
     * 社群專用廣告
     */
    path: '/social_FB_landing',
    name: RouteEnum.Landing,
    component: () => import('@/views/newLanding/SocialFaceBookView.vue'),
    meta: {
      layout: 'NoLayout',
      middleware: [auth, adMgmShareKey, device]
    }
  },
  {
    /**
     * 新版品牌通用推廣
     */
    path: '/social_coffee_gift',
    name: RouteEnum.LandingSocialCoffeeGift,
    component: () => import('@/views/newLanding/SocialCoffeeGiftView.vue'),
    meta: {
      layout: 'NoLayout',
      middleware: [auth, adMgmShareKey, device]
    }
  },
  {
    /**
     * 新版品牌通用推廣
     */
    path: '/social_common',
    name: RouteEnum.LandingSocialCommon,
    component: () => import('@/views/newLanding/SocialCommonView.vue'),
    meta: {
      layout: 'NoLayout',
      middleware: [auth, adMgmShareKey, device]
    }
  },
  {
    /**
     * FAQ
     */
    path: '/faq',
    name: RouteEnum.FAQ,
    component: () => import('@/views/faq/index.vue'),
    meta: {
      layout: 'NoLayout',
      middleware: [webview, auth]
    }
  },
  {
    /**
     * 學員心得分享檢視頁
     */
    path: '/student-testimonials-landing',
    name: RouteEnum.StudentTestimonialsLanding,
    component: () => import('@/views/testimonials/TestimonialsLandingView.vue'),
    meta: {
      layout: 'NoLayout',
      middleware: [auth]
    },
    beforeEnter: async () => {
      const userStore = useUserStore();
      if (userStore.hasLoginCondition) {
        return { name: RouteEnum.StudentTestimonialsSharing };
      }
    }
  }
];
